import { usePage } from '@inertiajs/vue3';
import { createGlobalState, isDefined } from '@vueuse/core';
import { computed, reactive } from 'vue';

const useUser = createGlobalState(() => {
  const user = computed(() => usePage()?.props?.user);

  return reactive({
    displayName: computed(() => user.value?.display_name),
    email: computed(() => user.value?.email),
    phoneNumber: computed(() => user.value?.phone_number),
    firstName: computed(() => user.value?.first_name),
    fullName: computed(() => user.value?.full_name),
    has_profile_photo: computed(() => user.value?.has_profile_photo),
    id: computed(() => user.value?.id),
    id_verification_session_url: computed(() => user.value?.id_verification_session_url),
    id_verified_at: computed(() => user.value?.id_verified_at),
    isAuthenticated: computed(() => user.value !== null),
    isIdVerified: computed(() => (
      isDefined(user.value?.id_verified_at) && new Date(user.value?.id_verified_at).getTime() > 0)),
    isPhoneNumberVerified: computed(() => (
      isDefined(user.value?.phone_number_verified_at) && new Date(user.value?.phone_number_verified_at).getTime() > 0)),
    isVerifiedToContactHost: computed(() => (user.value?.has_verified_to_contact_host)),
    isHost: computed(() => user.value?.is_host),
    isHousemate: computed(() => user.value?.primary_classification === 'housemate'),
    isOrganizationAccount: computed(() => Boolean(user.value?.is_organization_account)),
    lastName: computed(() => user.value?.last_name),
    primary_classification: computed(() => user.value?.primary_classification),
    profilePhoto: computed(() => user.value?.profile_photo),
    profile_photo_path: computed(() => user.value?.profile_photo_path),
    user,
  });
});

export default useUser;
